import { PhasrApplyActionPanelController } from '../controller/PhasrApplyActionPanelController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { ApplyActionCollections, PhasrApplyActionSchema } from '../types';

export class PhasrApplyActionPanelWebComponent extends BaseWebComponentElement {
  private gridData: PhasrApplyActionSchema;
  private _collection : ApplyActionCollections;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrApplyActionPanelController,
    });
  }

  public setGridData(data: PhasrApplyActionSchema): void {
    this.gridData = data;
  }

  public getGridData(): PhasrApplyActionSchema {
    return this.gridData;
  }

  public get collection(): ApplyActionCollections {
    return this._collection;
  }

  public set collection(value: ApplyActionCollections) {
    this._collection = value;
  }
}
